// ============================================
// ACTION HOOKS
// Combines hooks from:
// - [BuilderAction.tsx] BuilderAction (top-level) (ACTION 160)
// ============================================

import {useEffect} from 'react';
import {actionFieldsType} from '../BuilderAction/builderActionFields';
import {useBuilderContext} from '../CreateBuilder/useBuilderContext';
import {
  useAutoField,
  useLoadedAutoField,
  AutoFieldHelpers,
} from '../../../components/AutoForm/useAutoForm';
import {UPDATES} from '../../../shared/UPDATES';
import {OVRecommendation} from '../../../schema-types/OVRecommendation';
import {OvbuilderDetails_ovrecommendDetails} from '../../../schema-types/OvbuilderDetails';

export const loadActionNotes = ({
  builderDetails,
  helpers,
  setLoaded,
}: {
  builderDetails: OvbuilderDetails_ovrecommendDetails | null;
  helpers: AutoFieldHelpers<actionFieldsType['note']>;
  setLoaded: () => void;
}) => {
  if (!builderDetails) {
    setLoaded();
    return;
  }
  helpers.setValue(UPDATES._D160, builderDetails.note || '');
  setLoaded();
};

export const useLoadActionNotes = () => {
  const {loaded, setLoaded} = useLoadedAutoField();
  const [_, __, helpers] = useAutoField<actionFieldsType['note']>('action.note');
  const {builderDetails} = useBuilderContext();
  useEffect(() => {
    loadActionNotes({builderDetails, helpers, setLoaded});
  }, [builderDetails]);
  return {loaded};
};
